<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Broadcast
        div.small.text-muted
          | Mange your ongoing campaigns
      div.col-sm-7.hidden-sm-down
        b-btn.pull-right(type='button', variant='primary')
          i.icon-cloud-download
          |   Export
        broadcast-modal
    br
    broadcast-table
</template>
<script>
export default {
  name: 'dashboard',
  data() {
    return {
    }
  },
  mounted: function() {
  },
  methods: {
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Campaigns.vue?27f188c8